import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { withRouter } from 'react-router-dom'
import { IContinuationResponse } from '../../types/continuationScroll'
import { IEditionMetadata } from '../../types/pack'
import { push } from '../../actions/router'
import { getRevisions, prohibitedTab } from '../../services/pack'
import { updateQuery, getTab, getEdition } from '../../services/views'
import { DetailsTemplate } from '../../layouts'
import { RevisionsList, ContinuationScroll } from '../../components'

interface IEditionRevisionsTab {
  edition?: IEditionMetadata
  location: Location
  dispatch: Dispatch
}

export const EditionRevisionsTabComponent = ({
  edition,
  location,
  dispatch,
}: IEditionRevisionsTab) => {
  const revisionGroupId = edition?.file?.revisionGroupId
  if (
    (edition || getEdition(location) === 'overall-pack') &&
    prohibitedTab(getTab(location), edition)
  ) {
    dispatch(push(updateQuery({ tab: 'details' })(location)))
  }
  const getItems = useCallback(
    (token?: string): Promise<IContinuationResponse> =>
      getRevisions(revisionGroupId, token),
    [revisionGroupId]
  )
  return (
    <>
      <DetailsTemplate contentProps={{ id: 'pack-history-tab-main' }}>
        <ContinuationScroll
          getItems={revisionGroupId ? getItems : undefined}
          render={RevisionsList}
        />
      </DetailsTemplate>
    </>
  )
}

export const EditionRevisionsTab = withRouter(
  connect()(EditionRevisionsTabComponent)
)
